<template>
  <div>
    <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Event type</label>
    <div v-if="loading" class="h-9 bg-gray-100 dark:bg-gray-800 rounded-lg animate-pulse"></div>
    <select
      v-else
      :value="modelValue"
      @change="emit('update:modelValue', $event.target.value)"
      class="w-full h-9 px-3 text-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-[#1C2128] border border-gray-200 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    >
      <option value="">Select an event type...</option>
      <option v-for="event in events" :key="event.id" :value="event.id">
        {{ event.name }}
      </option>
    </select>
    <p v-if="!loading && events.length === 0" class="mt-1 text-xs text-gray-400 dark:text-gray-500">
      No event types found. Create one in Events first.
    </p>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: [String, Number], default: '' },
  events:     { type: Array,   required: true },
  loading:    { type: Boolean, default: false  },
})
const emit = defineEmits(['update:modelValue'])
</script>
